import React from 'react';

import type { DropZoneType } from '../../hooks/useDropZone';

export interface DropZoneIndicatorProps {
	type: DropZoneType;
	isVisible: boolean;
	position: 'top' | 'bottom' | 'inside';
}

export const DropZoneIndicator: React.FC<DropZoneIndicatorProps> = ({
	type,
	isVisible,
	position,
}) => {
	if (!isVisible) return null;

	const baseStyles = 'transition-all duration-200 ease-in-out';
	const positionStyles = {
		top: 'border-t-2',
		bottom: 'border-b-2',
		inside: 'border-l-4 ml-6',
	};

	const typeStyles = {
		'section-root': 'border-blue-500 bg-blue-50',
		'item-child': 'border-green-500 bg-green-50',
		'item-sibling': 'border-blue-500',
	};

	const labelText = {
		'section-root': 'Drop as root item',
		'item-child': 'Drop as child',
		'item-sibling': 'Drop as sibling',
	};

	return (
		<div
			className={`drop-zone-indicator ${baseStyles} ${positionStyles[position]} ${typeStyles[type]} py-2 px-3 rounded`}
		>
			<span className="text-xs font-medium text-gray-700">
				{labelText[type]}
			</span>
		</div>
	);
};
